import axios from 'axios';

axios.defaults.baseURL = 'http://api.funbase.com.ua/';

const optionAxios = {
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
}

class Data {
    getStart() {
        return axios.get('?unit=auth&operation=getStart');
    }
    logIn(data) {
        return axios.post('?unit=auth&operation=admin', { ...data } );
    }
    addCases(data) {
        return axios.post('?unit=cases&operation=addCase', { ...data });
    }
    deleteCase(data) {
        return axios.post('?unit=cases&operation=deleteCase', data)
    }
    editCase(data) {
        return axios.post('?unit=cases&operation=editCase', data)
    }
    addService(data) {
        return axios.post('?unit=services&operation=addService', { ...data })
    }
    deleteService(data) {
        return axios.post('?unit=services&operation=deleteService', data)
    }
    editService(data) {
        return axios.post('?unit=services&operation=editService', data);
    }
    reLoginAndPassword(data) {
        return axios.post('?unit=auth&operation=editAuthData', data);
    }
}

export default new Data();




// WEBPACK FOOTER //
// ./src/API.js